import API from "./API"

interface requestedUrl{ //lista de urls com os dados do request
    [url: string]: requestedData
}
type requestedData = {
    response: any,
    validUntil: number,
    url: string
}

const url = {
    base: 'https://api.cnptia.embrapa.br/',
    agritec_culturas: 'https://api.cnptia.embrapa.br/agritec/v2/culturas',
    agritec_cultivares: 'https://api.cnptia.embrapa.br/agritec/v2/cultivares',
    bioinsumos_titulares: 'https://api.cnptia.embrapa.br/bioinsumos/v2/titulares-registros',
    bioinsumos_produtos: 'https://api.cnptia.embrapa.br/bioinsumos/v2/search/produtos-biologicos?',
}
const key = {
    // agritec: '25a5fa6c-a2b1-3e61-820a-8f587beb2c3c', // Expira dia 3 de Junho de 2025
    agritec: '566b0876-4b25-3f2e-9ddd-f324a77696a8',
    // bioinsumos: 'd0bbc501-1173-3186-8477-0ff54b724513' 
    bioinsumos: '25a5fa6c-a2b1-3e61-820a-8f587beb2c3c'
}
const saveTime = 1000*60*60*24*4 //4 dias
const fetchOrLoad = async (url: string, key: string, maxAge: number = saveTime, asyncSave: boolean = true)=>{
    const savedRequests = JSON.parse(localStorage.getItem('savedRequests')||'{}') as requestedUrl
    const savedUrl = savedRequests[url]
    if (savedUrl&&Date.now()<savedUrl.validUntil){
        await filterAndSave(savedRequests)
        return savedRequests[url].response
    }
    const request = await(await fetch(url, {headers: API.getHeaders(key)})).json() //Caso der erro, não executa o resto
    const saved: requestedUrl = savedRequests
    saved[url] = {response: request, validUntil: Date.now()+maxAge, url: url}
    if (asyncSave){
        filterAndSave(saved)
    } else {
        await filterAndSave(saved)
    }
    return request
}
const filterAndSave = async (toSave: requestedUrl)=>{
    const items: requestedUrl = {}
    const now = Date.now()
    for (let i in toSave){
        if (toSave[i].validUntil>now){
            items[i] = toSave[i]
        }
    }
    let stringfied = JSON.stringify(items)
    if (stringfied.length>5000000){
        console.log('Saved Requests are way too large for localStorage. All data will be purged to prevent errors.')
        localStorage.removeItem('savedRequests')
        return
    }
    localStorage.setItem('savedRequests', stringfied)
}
const Embrapa = {
    urls: url,
    keys: key,
    fetchOrLoad: fetchOrLoad,
}
export default Embrapa;